module.exports = __webpack_public_path__ + "static/scale-model-of-forney-museum-of-transportation-in-denver-colorado-556b8014ca6697224544b71a055341a6.png";